module.exports = __webpack_public_path__ + "media/images/titlebg-187edac6f55743952a2256c45d67409c.png";